
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase URL or Anon Key');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        // Persist session in localStorage for faster re-hydration
        persistSession: true,
        // Auto-refresh token before it expires
        autoRefreshToken: true,
        // Detect session from URL (e.g., OAuth redirects)
        detectSessionInUrl: true,
    },
    global: {
        headers: {
            'x-client-info': 'vigorhub-web',
        },
    },
    // Realtime connection resilience
    realtime: {
        params: {
            eventsPerSecond: 10,
        },
    },
});
